import { render, staticRenderFns } from "./GaitFeatureTimeChartCard.vue?vue&type=template&id=b77c3d02&scoped=true&"
import script from "./GaitFeatureTimeChartCard.vue?vue&type=script&lang=js&"
export * from "./GaitFeatureTimeChartCard.vue?vue&type=script&lang=js&"
import style0 from "./GaitFeatureTimeChartCard.vue?vue&type=style&index=0&id=b77c3d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c3d02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
